import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TravelSearchAggregatorModel')
export default class TravelSearchAggregatorModel {
  @JsonProperty('aggregator_id', Number) public aggregatorId:number = -1;
  @JsonProperty('aggregator_name', String) public aggregatorName:string = undefined;
  @JsonProperty('last_error_status', String) public lastErrorStatus:string = undefined;
  @JsonProperty('status', String) public status:string = undefined;
}